import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const fundingData = [{
  date: 'Apr 1',
  rate: 0.0082
}, {
  date: 'Apr 3',
  rate: 0.0095
}, {
  date: 'Apr 5',
  rate: -0.0032
}, {
  date: 'Apr 7',
  rate: 0.0071
}, {
  date: 'Apr 9',
  rate: -0.0048
}, {
  date: 'Apr 11',
  rate: 0.0063
}, {
  date: 'Apr 13',
  rate: 0.0104
}, {
  date: 'Apr 15',
  rate: -0.0019
}, {
  date: 'Apr 17',
  rate: 0.0088
}, {
  date: 'Apr 19',
  rate: 0.0056
}, {
  date: 'Apr 21',
  rate: -0.0041
}, {
  date: 'Apr 23',
  rate: 0.0073
}, {
  date: 'Apr 25',
  rate: 0.0091
}, {
  date: 'Apr 27',
  rate: -0.0027
}, {
  date: 'Apr 29',
  rate: 0.0068
}];
const CustomTooltip = ({
  active,
  payload
}: any) => {
  if (!active || !payload || !payload.length) return null;
  const data = payload[0].payload;
  const rate = data.rate;
  const isPositive = rate >= 0;
  return <div style={{
    background: 'rgba(20, 22, 32, 0.65)',
    backdropFilter: 'blur(32px) saturate(180%)',
    WebkitBackdropFilter: 'blur(32px) saturate(180%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '28px',
    padding: '16px 20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)'
  }} data-id="element-57">
      <div style={{
      color: '#9CA3AF',
      fontSize: '11px',
      marginBottom: '8px',
      letterSpacing: '0.05em',
      fontWeight: '400',
      textTransform: 'uppercase' as const
    }} data-id="element-58">
        {data.date}
      </div>
      <div style={{
      color: isPositive ? '#00C87F' : '#E85D75',
      fontSize: '28px',
      fontWeight: '300',
      letterSpacing: '-0.02em'
    }} data-id="element-59">
        {isPositive ? '+' : ''}
        {(rate * 100).toFixed(4)}%
      </div>
    </div>;
};
export function FundingRateChart() {
  return <div className="glass-border rounded-[20px] p-6" data-id="element-60">
      <div className="flex items-center justify-between mb-1" data-id="element-61">
        <h3 className="text-sm font-heading text-text-primary" data-id="element-62">
          Funding Rate History
        </h3>
      </div>
      <div className="flex items-center gap-4 mb-6" data-id="element-63">
        <span className="text-xs font-numbers text-text-secondary" data-id="element-64">
          Avg Rate: <span className="text-success" data-id="element-65">+0.0062%</span>
        </span>
        <span className="text-xs font-numbers text-text-secondary" data-id="element-66">
          Total Paid: <span className="text-danger" data-id="element-67">-$42.18</span>
        </span>
      </div>

      <div style={{
      width: '100%',
      height: 300
    }} data-id="element-68">
        <ResponsiveContainer width="100%" height="100%" data-id="element-69">
          <BarChart data={fundingData} margin={{
          left: 10,
          right: 10,
          top: 10,
          bottom: 10
        }} data-id="element-70">
            <CartesianGrid strokeDasharray="3 3" stroke="#2B3139" vertical={false} opacity={0.3} data-id="element-71" />
            <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
            fill: '#848E9C',
            fontSize: 11
          }} dy={5} interval="preserveStartEnd" minTickGap={30} data-id="element-72" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#848E9C',
            fontSize: 11
          }} tickFormatter={(v: number) => `${(v * 100).toFixed(2)}%`} width={60} data-id="element-73" />
            <Tooltip content={<CustomTooltip data-id="element-75" />} cursor={{
            fill: 'rgba(255, 255, 255, 0.03)'
          }} data-id="element-74" />
            <Bar dataKey="rate" radius={[4, 4, 0, 0]} maxBarSize={24} data-id="element-76">
              {fundingData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.rate >= 0 ? '#00C87F' : '#E85D75'} data-id="element-77" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}